<template>
  <div
    id="layout"
    class="antialiased bg-white text-stone-900 font-sans"
    :class="{ 'border-b': !hideFooter }"
    :style="pageBackground ? { backgroundColor: pageBackground } : undefined"
  >
    <client-only>
      <Sidebars />
    </client-only>

    <header>
      <ErrorBoundary>
        <client-only>
          <Notifications />
        </client-only>
        <NavbarMinimal />
      </ErrorBoundary>
      <slot name="banner" />
    </header>

    <ErrorBoundary>
      <main :class="{ 'no-footer': hideFooter }">
        <PageLoader />
        <slot />
      </main>
    </ErrorBoundary>

    <slot v-if="!hideFooter" name="footer">
      <ErrorBoundary>
        <NuxtLazyHydrate when-visible>
          <Footer
            :footer-block-items="footerBlock"
            :display-newsletter-subscription-form="false"
            class="!pb-4 pt-4"
          />
        </NuxtLazyHydrate>
      </ErrorBoundary>
    </slot>
  </div>
</template>
<script lang="ts" setup>
const { locale } = useI18n()
const route = useRoute()

// opt-in per page via definePageMeta({ pageBackground: '#f8f6f2' })
const pageBackground = computed(
  () => route.meta.pageBackground as string | undefined
)

// opt-in per page via definePageMeta({ hideFooter: true })
const hideFooter = computed(() => route.meta.hideFooter === true)

const { data: footerData } = await useStrapiSingleType(
  `footer?locale=${locale.value}&populate[footerBlock][populate]=*`
)

const { setupValidationPolling, deactivateValidationPolling } =
  useCartValidation()

// remove links in footer and only have payment methods, follow us and locale switcher
const footerBlock = footerData?.value?.data?.footerBlock?.slice(3) || []

onMounted(() => {
  setupValidationPolling()
})

onUnmounted(() => {
  deactivateValidationPolling()
})

useLayoutHead()
</script>

<style lang="postcss" scoped>
#layout {
  box-sizing: border-box;
}

header {
  @apply sticky top-0 z-20;
}

main {
  /*
    71px - header height
    174px - footer height
    5rem - footer margin
  */
  min-height: calc(100vh - 71px - 174px - 5rem);
  position: relative;

  /* the min-height only exists to push the footer down. Without a footer it
     would stretch the page background below the content (e.g. below a
     page's sticky bottom bar on tall screens), so let the content decide */
  &.no-footer {
    min-height: auto;
  }
}
</style>

<style>
.Toastify__toast-container {
  max-width: 480px;
  --toastify-toast-width: max-content;
}
</style>
